export default __webpack_public_path__ + "static/media/blob (3).fbfc3970.svg";